import { render, staticRenderFns } from "./SampleRequestEditTabDesign.vue?vue&type=template&id=8de3c336&"
import script from "./SampleRequestEditTabDesign.vue?vue&type=script&lang=js&"
export * from "./SampleRequestEditTabDesign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports